function toQueryString(obj: Record<string, any>): string {
    const vet = ['string', 'number', 'boolean']
    const vet2 = ['undefined', 'null']

    return Object.keys(obj)
        .filter(key => vet.includes(typeof obj[key]))
        .map(key => (!vet2.includes(typeof obj[key]) ? `${key}=${obj[key]}` : undefined))
        .filter(e => e)
        .join('&')
}

export function setParamsBuilder(url: string) {
    return function(params: Record<string, any>): void {
        window.location.href = `${url}?${toQueryString(params)}`
    }
}
